<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item label="支付图片" prop="transferUrl" >
        <a-upload
          listType="picture-card"
          class="avatar-uploader"
          v-model="form.transferUrl"
          :showUploadList="false"
          :customRequest="handleChange"
        >
          <img v-if="form.transferUrl" :src="form.transferUrl" alt="logo"
               style="height:104px;max-width:300px"/>
          <div v-else>
            <a-icon :type="uploadLoading ? 'loading' : 'plus'"/>
            <div class="ant-upload-text">上传</div>
          </div>
        </a-upload>
      </a-form-model-item>
      <a-form-model-item label="套餐" prop="menuId" >
        <a-select placeholder="请选择套餐" v-model="form.menuId" style="width: 100%" allow-clear>
          <a-select-option v-for="(d, index) in menuList" :key="index" :value="d.id">{{ d.menuName }}-价格:{{d.price}}</a-select-option>
        </a-select>
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            保存
          </a-button>
          <a-button type="dashed" @click="cancel">
            取消
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getJoe, addJoe, updateJoe,getMenuList } from '@/api/joe/order'
import ossUpload from "@/utils/ossUpload";

export default {
  name: 'CreateForm',
  props: {
  },
  components: {
  },
  data () {
    return {
      submitLoading: false,
      uploadLoading: false,
      formTitle: '',
      menuList: [],
      // 表单参数
      form: {
        id: null,

        sysUserId: null,

        transferUrl: null,

        menuId: null,

        payMoney: null,

        status: 0,

        createTime: null,

        remark: null,

      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
      }
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    onClose () {
      this.open = false
    },
    handleChange(info) { //上传图片回调
      var that = this;
      this.uploadLoading = true;
      ossUpload.ossUpload(info.file, function (fileName) {
        that.uploadLoading = false;
        that.form.transferUrl = fileName;
      });
    },
    getMenuList() {
      getMenuList().then(response => {
        this.menuList = response.data
      })
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        sysUserId: null,
        transferUrl: null,
        menuId: null,
        payMoney: null,
        status: 0,
        createTime: null,
        remark: null,
      }
      this.$nextTick(() => {
        if(this.$refs.form){
          this.$refs.form.resetFields()
        }
      })
    },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.getMenuList()
      this.formTitle = '添加'
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.getMenuList()
      this.formType = 2
      const id = row ? row.id : ids
      getJoe({"id":id}).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = '修改'
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          if (this.form.id !== undefined && this.form.id !== null) {
            updateJoe(this.form).then(response => {
              this.$message.success(
                '修改成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            addJoe(this.form).then(response => {
              this.$message.success(
                '新增成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
